import { getSectionList } from '@/api/section'

export async function getSectionInfo(id) {
  let sectionList = await getSectionList();
  let sectionListWithoutId = sectionList.filter(v => v.id !== id)

  let sectionNow = sectionList.filter(v => v.id === id)[0]

  let imageUrlForId = sectionNow?.artworks?.[0]?.imageMainUrl ?? ''
  let artworksForId = sectionNow?.artworks ?? ''

  return { sectionList, sectionListWithoutId, imageUrlForId, artworksForId}
}